var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMenuHandleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 378,
    viewBox: "0 0 123 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M55.5468 292.676L50.1202 308.516C50.1202 308.516 48.7602 312.836 51.0002 317.329L38.627 331.622L40.2536 312.156L55.5468 292.689V292.676Z",
    fill: "url(#paint0_linear_318_2399)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0921 37.6788C46.252 68.5185 59.8119 92.8515 59.8119 92.8515C62.9185 99.6781 67.1585 108.865 67.1585 108.865C68.9584 112.758 72.0651 120.958 72.0651 120.958C63.1585 111.131 57.3852 102.531 50.5853 93.6382C37.4388 76.4517 28.4789 46.1587 24.1056 28.5322C22.0389 20.2523 20.9989 14.759 20.9989 14.759C13.3857 11.0657 9.33239 8.78575 8.8524 8.50575C8.14574 8.15909 7.43908 7.83909 6.73242 7.51909C9.83906 3.41247 13.639 0.359165 13.639 0.359165C25.4256 -1.41415 30.2655 5.03912 30.2655 5.03912C30.9722 10.9724 31.9588 16.7057 33.1321 22.1856C34.2921 27.5856 35.6388 32.7588 37.0921 37.6654V37.6788Z",
    fill: "url(#paint1_linear_318_2399)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1457 108.865C67.1457 108.865 60.5057 94.1585 60.0658 93.4251C60.0658 93.4251 46.2526 68.5187 37.0927 37.6791C35.6393 32.7724 34.2927 27.5992 33.1327 22.1992C33.1327 22.1992 30.7727 63.3721 67.1457 108.865Z",
    fill: "url(#paint2_linear_318_2399)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1455 30.9305C23.1455 30.9305 24.5588 32.3838 28.8121 45.6637C28.8121 45.6637 27.3588 27.1039 22.5322 12.2507C22.5322 12.2507 17.4922 2.82414 13.5456 0.4375C12.9323 0.944161 8.13232 4.19746 1.03906 14.3574C1.74572 14.6774 3.9057 16.384 4.61236 16.7307C5.09235 16.9973 12.2656 22.1973 23.1588 30.9305H23.1455Z",
    fill: "url(#paint3_linear_318_2399)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M30.2672 5.03915C30.2672 5.03915 26.0806 -0.534123 16.0273 0.10587C20.3073 5.97248 28.4805 7.37246 30.2672 5.03915Z",
    fill: "url(#paint4_linear_318_2399)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1458 30.9311L20.0925 22.1979C16.0258 16.7313 11.3592 13.918 11.3592 13.918C11.3592 13.918 7.23926 14.5046 3.2793 15.8646L4.61262 16.7313C14.2125 23.0512 23.1591 30.9311 23.1591 30.9311H23.1458Z",
    fill: "url(#paint5_linear_318_2399)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M64.8803 112.531C64.8803 112.531 62.2803 105.998 60.387 99.9579L57.707 88.918C58.0937 89.398 59.3337 92.2513 59.8137 92.8379C64.8936 102.998 67.8269 109.411 72.0669 120.944C72.0669 120.944 66.8803 114.771 64.8936 112.518L64.8803 112.531Z",
    fill: "url(#paint6_linear_318_2399)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.56 138.532C89.56 138.532 103.947 153.705 112.533 188.638H122.08C122.08 188.638 119.826 150.172 83.0801 117.332L89.56 138.532Z",
    fill: "url(#paint7_linear_318_2399)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0921 339.607C46.252 308.768 59.8119 284.434 59.8119 284.434C62.9185 277.608 67.1585 268.421 67.1585 268.421C68.9584 264.528 72.0651 256.328 72.0651 256.328C63.1585 266.155 57.3852 274.755 50.5853 283.648C37.4388 300.834 28.4789 331.127 24.1056 348.754C22.0389 357.034 20.9989 362.527 20.9989 362.527C13.3857 366.22 9.33239 368.5 8.8524 368.78C8.14574 369.127 7.43908 369.447 6.73242 369.767C9.85239 373.874 13.6523 376.927 13.6523 376.927C25.4389 378.7 30.2788 372.247 30.2788 372.247C30.9855 366.314 31.9722 360.58 33.1455 355.1C34.3055 349.7 35.6521 344.527 37.1054 339.621L37.0921 339.607Z",
    fill: "url(#paint8_linear_318_2399)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1457 268.422C67.1457 268.422 60.5057 283.128 60.0658 283.862C60.0658 283.862 46.2526 308.768 37.0927 339.608C35.6393 344.514 34.2927 349.688 33.1327 355.088C33.1327 355.088 30.7727 313.915 67.1457 268.422Z",
    fill: "url(#paint9_linear_318_2399)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2131 345.261C24.2131 345.261 24.5597 344.901 28.813 331.621C28.813 331.621 27.3597 350.181 22.5331 365.034C22.5331 365.034 17.4932 374.461 13.5465 376.847C12.9332 376.341 2.82664 367.327 0 363.607C0.706659 363.287 5.31994 359.927 6.0266 359.581C6.5066 359.314 15.1732 353.728 24.2131 345.261Z",
    fill: "url(#paint10_linear_318_2399)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2672 372.248C30.2672 372.248 26.0806 377.821 16.0273 377.181C20.3073 371.315 28.4805 369.915 30.2672 372.248Z",
    fill: "url(#paint11_linear_318_2399)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2126 345.262L21.6127 352.475C19.706 359.048 14.9461 364.048 14.9461 364.048C14.9461 364.048 11.5994 364.742 8.6128 363.168L4.82617 360.355C6.73282 359.328 17.826 350.755 24.2126 345.275V345.262Z",
    fill: "url(#paint12_linear_318_2399)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M64.8803 264.757C64.8803 264.757 62.2803 271.29 60.387 277.33L57.707 288.37C58.0937 287.89 59.3337 285.037 59.8137 284.45C64.8936 274.29 67.8269 267.877 72.0669 256.344C72.0669 256.344 66.8803 262.517 64.8936 264.77L64.8803 264.757Z",
    fill: "url(#paint13_linear_318_2399)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.56 238.758C89.56 238.758 103.947 223.585 112.533 188.652H122.08C122.08 188.652 119.826 227.119 83.0801 259.958L89.56 238.758Z",
    fill: "url(#paint14_linear_318_2399)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.531 188.636C104.385 154.57 89.5582 138.53 89.5582 138.53L85.8516 126.41C113.051 152.183 117.465 188.636 117.465 188.636C117.465 188.636 113.051 225.102 85.8516 250.862L89.5582 238.742C89.5582 238.742 104.385 222.689 112.531 188.636Z",
    fill: "url(#paint15_linear_318_2399)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M92.8533 234.543C92.8533 234.543 91.7333 241.45 91.9067 244.57L89.56 253.756L83.0801 259.956L85.8534 250.876L89.56 238.756L92.8533 234.543Z",
    fill: "url(#paint16_linear_318_2399)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M83.0801 117.332L85.8534 126.412L89.56 138.532L92.8533 142.745V133.825L85.8534 119.892L83.0801 117.332Z",
    fill: "url(#paint17_linear_318_2399)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_2399",
    x1: 47.0935,
    y1: 185.09,
    x2: 47.0935,
    y2: 252.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_2399",
    x1: 81.4067,
    y1: 39.9836,
    x2: 25.8644,
    y2: 69.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_2399",
    x1: 24.4011,
    y1: 79.2706,
    x2: 73.6663,
    y2: 52.8992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_2399",
    x1: 12.8595,
    y1: 27.4789,
    x2: 30.4803,
    y2: 18.0466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_2399",
    x1: 28.5177,
    y1: -0.227721,
    x2: 13.9062,
    y2: 7.59374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_2399",
    x1: -46.2935,
    y1: 39.651,
    x2: 27.839,
    y2: 19.3446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_2399",
    x1: 65.7612,
    y1: 104.436,
    x2: 61.4942,
    y2: 106.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_2399",
    x1: 106.853,
    y1: 161.212,
    x2: 120.68,
    y2: 188.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_2399",
    x1: 81.1818,
    y1: 337.146,
    x2: 25.6395,
    y2: 307.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_2399",
    x1: 24.1762,
    y1: 297.86,
    x2: 73.4414,
    y2: 324.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_2399",
    x1: 12.2178,
    y1: 349.441,
    x2: 30.3675,
    y2: 359.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_2399",
    x1: 28.2927,
    y1: 377.359,
    x2: 13.6813,
    y2: 369.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_2399",
    x1: -18.7969,
    y1: 335.366,
    x2: -0.976361,
    y2: 344.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_2399",
    x1: 65.5363,
    y1: 272.695,
    x2: 61.2692,
    y2: 270.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_2399",
    x1: 122.64,
    y1: 238.892,
    x2: 103.227,
    y2: 224.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_2399",
    x1: 60.7318,
    y1: 206.343,
    x2: 112.505,
    y2: 169.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_2399",
    x1: 87.9734,
    y1: 164.357,
    x2: 87.9734,
    y2: 208.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_2399",
    x1: 87.9734,
    y1: 47.1461,
    x2: 87.9734,
    y2: 91.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMenuHandleRight);
export default __webpack_public_path__ + "static/media/quick-menu-handle-right.0564a32d8a29adc92e2b1c64d1f16213.svg";
export { ForwardRef as ReactComponent };